"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var graphql_tag_1 = require("graphql-tag");
var lodash_1 = require("lodash");
var client_1 = require("../client");
var SimilarAthletesDummyData_1 = require("../data/SimilarAthletesDummyData");
var athlinks_results_model_1 = require("athlinks-results-model");
exports.maybeSynthesizeTimeZone = function (_a) {
    var _b = _a.startDateTime, timeInMilliseconds = _b.timeInMilliseconds, timeZone = _b.timeZone, theRest = __rest(_a, ["startDateTime"]);
    return (__assign({}, theRest, { startDateTime: {
            timeInMilliseconds: timeInMilliseconds,
            timeZone: timeZone || 'America/Denver'
        }, synthesizedTimeZone: !!!timeZone }));
};
exports.extractAthleteRacePage = function (_a) {
    var _b = _a.data.getAthleteRaceData, claimed = _b.claimed, entryId = _b.entryId, _c = _b.athlete, ageOnRaceDay = _c.ageOnRaceDay, firstName = _c.firstName, keycloakId = _c.keycloakId, lastName = _c.lastName, gender = _c.gender, location = _c.location, racerId = _c.racerId, coursesCardModel = _b.courses, event = _b.event, isLoggedIn = _b.isLoggedIn, isMe = _b.isMe, bib = _b.bib, irp = _b.irp;
    return ({
        claimed: claimed,
        athleteCardModel: {
            ageOnRaceDay: ageOnRaceDay,
            bib: bib,
            claimed: claimed,
            displayName: firstName + " " + lastName.slice(0)[0],
            entryId: entryId,
            firstName: firstName,
            gender: gender ? gender : 'unspecified',
            isFollowed: false,
            isLoggedIn: isLoggedIn,
            isMe: isMe,
            keycloakId: keycloakId,
            lastName: lastName,
            location: location,
            racerId: racerId
        },
        entryId: entryId,
        coursesCardModel: coursesCardModel,
        eventCardModel: exports.maybeSynthesizeTimeZone(event),
        isLoggedIn: isLoggedIn,
        isMe: isMe,
        raceCardModel: __assign({}, exports.maybeSynthesizeTimeZone(event), { irp: irp, courses: lodash_1.map(coursesCardModel, function (course) { return (__assign({}, course, { goalTime: {
                    timeInMillis: 1320000,
                    timeUnit: athlinks_results_model_1.TimeUnit.MINUTES
                }, goalPace: {
                    distance: {
                        distanceInMeters: 1609.34,
                        distanceUnit: athlinks_results_model_1.DistanceUnit.MILES
                    },
                    time: {
                        timeInMillis: 480000,
                        timeUnit: athlinks_results_model_1.TimeUnit.MINUTES
                    },
                    paceType: athlinks_results_model_1.PaceType.PACE
                } })); }) }),
        similarAthletesCardModel: SimilarAthletesDummyData_1.similarAthletesDummyData
    });
};
exports.getARP = function (id, token) { return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
    var apolloClient;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, client_1.getClient(token)];
            case 1:
                apolloClient = _a.sent();
                apolloClient.query({
                    query: graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query GetAthleteRaceData($id: ID!) {\n      getAthleteRaceData(entryId: $id) {\n        entryId,\n        athlete {\n          ageOnRaceDay,\n          firstName,\n          keycloakId,\n          lastName,\n          gender,\n          location {\n            city,\n            country,\n            postalCode,\n            region,\n            street,\n            street2,\n          },\n          racerId\n        },\n        event {\n          eventId,\n          name,\n          location {\n            city,\n            country,\n            postalCode,\n            region,\n            street,\n            street2\n          },\n          startDateTime {\n            timeInMilliseconds,\n            timeZone\n          }\n        },\n        courses {\n          courseId,\n          distance {\n            distanceInMeters,\n            distanceUnit\n          },\n          name\n        },\n        isLoggedIn,\n        isMe,\n        bib,\n        irp,\n        claimed\n      }\n    }\n    "], ["\n    query GetAthleteRaceData($id: ID!) {\n      getAthleteRaceData(entryId: $id) {\n        entryId,\n        athlete {\n          ageOnRaceDay,\n          firstName,\n          keycloakId,\n          lastName,\n          gender,\n          location {\n            city,\n            country,\n            postalCode,\n            region,\n            street,\n            street2,\n          },\n          racerId\n        },\n        event {\n          eventId,\n          name,\n          location {\n            city,\n            country,\n            postalCode,\n            region,\n            street,\n            street2\n          },\n          startDateTime {\n            timeInMilliseconds,\n            timeZone\n          }\n        },\n        courses {\n          courseId,\n          distance {\n            distanceInMeters,\n            distanceUnit\n          },\n          name\n        },\n        isLoggedIn,\n        isMe,\n        bib,\n        irp,\n        claimed\n      }\n    }\n    "]))),
                    variables: {
                        id: id
                    }
                }).then(lodash_1.flow(exports.extractAthleteRacePage, resolve))
                    .catch(function (error) {
                    reject(new Error("ARP lookup failed for entryId \"" + id + "\": \"" + error + "\""));
                });
                return [2 /*return*/];
        }
    });
}); }); };
var templateObject_1;
//# sourceMappingURL=getARP.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlete-api-client/dist/requests/getARP.js
 ** module id = 2070
 ** module chunks = 0
 **/